import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { Api } from './models/apiWrappers/api/api';
import { DEFAULT_API_CONFIG } from './models/apiWrappers/api/api-config';
import { Provider as MSTProvider, rootStoreInitialState } from './models/rootModel';
import { BrowserRouter } from 'react-router-dom';

import { AnalyticsProvider } from './utils/analytics';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
export const api = new Api(DEFAULT_API_CONFIG);

root.render(
  <AnalyticsProvider writeKey={process.env.REACT_APP_SEGMENT_API_KEY || ''}>
    <MSTProvider value={rootStoreInitialState}>
      <BrowserRouter basename="/onboarding">
        <App />
      </BrowserRouter>
    </MSTProvider>
  </AnalyticsProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
